import { render, staticRenderFns } from "./FormCostFactor.vue?vue&type=template&id=27bf07ab&scoped=true&"
import script from "./FormCostFactor.vue?vue&type=script&lang=ts&"
export * from "./FormCostFactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bf07ab",
  null
  
)

export default component.exports